export function checkAndHideAmountLines() {

    const basePriceElement = document.getElementById("price_base_without_customization");
    const amountLinesElement = document.querySelector(".amountLines");

    if (basePriceElement && amountLinesElement) {
        const priceText = basePriceElement.textContent.trim();

        if (priceText === "CHF 0.00") {
            amountLinesElement.style.display = "none";
        }
    }
}